import React, { ReactElement } from 'react';

import s from './Facts.module.scss';
import staticPageStyles from '../StaticPage.module.scss';
import getAssetLink from '../../../util/getAssetLink';
import { withSEO } from '../../SEO/withSEO';

function Facts(): ReactElement {
  return (
    <div className={staticPageStyles.staticPage} data-nosnippet>
      <div className={staticPageStyles.card}>
        <div className={staticPageStyles.cardHeader}>
          <img src={getAssetLink('startpage/facts.png')} alt="" />
          <h1>FACTS</h1>
        </div>
        <div className={staticPageStyles.cardContent}>
          <p>
            <h2>Warum heißt es eigentlich „Jopsy“?</h2>
            Die Bezeichnung umfasst die beiden wesentlichen Grundpfeiler des
            Angebots: Du findest <b>Jo</b>bvorschläge anhand eines <b>psy</b>
            chologisch erprobten Modells. Viel Spaß dabei!
          </p>
          <p>
            <h2>Worauf basiert Jopsy?</h2>
            Jopsy nutzt ein wissenschaftlich erprobtes Modell (RIASEC) für die
            Berufsberatung, das in vielen Ländern im Einsatz ist. Dieses Modell
            geht davon aus, dass man Menschen nach ihren Interessen grob in 6
            Typen teilen kann, wobei wir alle eine Mischung aus diesen Typen
            sind, niemand ist zB zu 100% nur Gestalter:in oder Macher:in. Auf
            Basis dieser Interessen können dann Berufe zugordnet werden, die zu
            dem jeweiligen Profil passen.
          </p>
          <p>
            <h2>Was zeigt dir dein Ergebnisscreen?</h2>
            Dein Ergebnisscreen zeigt dir drei Dinge: das Interessenprofil mit
            deinen drei dominanten Interessentypen, die Profilgenauigkeit und
            die Berufsvorschläge, die auf Basis deines Interessenprofils
            erstellt werden. Zu deinen Interessentypen findest du mehr Infos,
            wenn du in die färbigen Balken klickst; Kurzerklärungen beschreiben
            dir die vorgeschlagenen Berufe näher.
          </p>
          <p>
            <h2>Wie kommt es zu den Berufsvorschlägen?</h2>
            Die Berufe werden auf Basis deines Interessenprofils erstellt. Das
            wissenschaftliche Modell (RIASEC-Modell), das hinter Jopsy steckt,
            geht davon aus, dass du dann langfristig zufrieden und gut in deinem
            Beruf bist, wenn deine eigenen Interessen sich im Berufsbild
            wiederfinden.
          </p>
          <p>
            <h2>
              So viele mögliche Ausbildungen und Berufe! Was hilft mir bei
              meiner Entscheidung?
            </h2>
            Versuche noch mehr über deine Interessen, Stärken und Werte
            herauszufinden. Probiere viel aus, mach neue Erfahrungen, so lernst
            du dich noch besser kennen. Recherchiere im Internet und sprich mit
            Personen, die Berufe ausüben, die dich interessieren.
          </p>
          <p>
            <h2>
              Keiner der vorgeschlagenen Berufe interessiert mich. Was nun?
            </h2>
            Die vorgeschlagenen Berufe sind Anregungen und Vorschläge. Es
            bedeutet nicht, dass nur diese Berufe zu dir passen, sondern, dass
            diese Berufe besonders gut zu deinem Interessenprofil passen.
            <br />
            Such dir aus der Jopsy-Berufsliste ein paar Berufe aus, die dir am
            ehesten gefallen und versuche noch mehr darüber herauszufinden.
            Vielleicht hast du die Gelegenheit, typische Aufgabenbereiche dieser
            Berufe kennenzulernen oder auszuprobieren. So kannst du am besten
            herausfinden, ob diese Ausbildung oder dieser Beruf vielleicht doch
            zu dir passt.
          </p>
          <p>
            <h2>
              Ich möchte mehr über einen Beruf erfahren. Wo bekomme ich nähere
              Infos?
            </h2>
            Die umfangreiche Berufsdatenbank des AMS (Arbeitsmarktservice)
            findest du unter{' '}
            <a
              href="http://www.berufslexikon.at"
              target="_blank"
              rel="noreferrer"
            >
              www.berufslexikon.at
            </a>{' '}
            oder recherchiere auf{' '}
            <a href="https://www.bic.at/" target="_blank" rel="noreferrer">
              www.bic.at
            </a>
            .
          </p>
          <p>
            <h2>
              Die Profilgenauigkeit ist nicht besonders hoch - Was bedeutet das?
            </h2>
            Ein niedriger Wert deutet darauf hin, dass deine Interessen eher
            breit gestreut und nicht eindeutig zuzuordnen sind. Vielleicht
            kannst du dich aber trotzdem mit deinem Interessenprofil
            identifizieren.
            <br />
            Oder es hilft dir, wenn du dich mit verschiedenen Berufen näher
            auseinandersetzt, um so ein genaueres Bild davon zu bekommen, was
            dir gefallen könnte.
          </p>
          <p>
            <h2>
              Kann ich auch einen Beruf wählen/anstreben, der nicht meinen
              Interessen entspricht?
            </h2>
            Natürlich kannst du auch einen Beruf wählen, der nicht deinen
            momentanen Interessen entspricht. Deine Interessen können sich im
            Laufe der Zeit ändern. Bei der Berufswahl zählen nicht nur die
            Interessen. Auch deine Talente, Stärken und Begabungen sind wichtig.
            Außerdem solltest du auch Aspekte wie die zukünftige Bezahlung, die
            Nähe zur Ausbildungsstätte und die Arbeitszeiten berücksichtigen. Es
            kann sein, dass du manche Interessen nicht in deinem Beruf ausleben
            kannst. Diesen kannst du dich in deiner Freizeit widmen.
          </p>
          <p>
            <h2>
              Ich habe Jopsy noch einmal gemacht und nun ganz andere Ergebnisse,
              was bedeutet das?
            </h2>
            Dies kann passieren, wenn deine Interessen noch nicht eindeutig
            ausgeprägt sind oder wenn du das Tool das letzte Mal vor längerer
            Zeit gemacht hast. Dann kann es auch sein, dass sich deine
            Interessen geändert haben, denn unsere alltäglichen Erfahrungen
            beeinflussen und verändern unsere Interessen.
          </p>
          <p>
            <h2>Sind meine Angaben anonym?</h2>
            Jopsy ist absolut anonym und du entscheidest, wer deine Ergebnisse
            sehen darf. Es werden keine Daten an Dritte weitergegeben. Wenn du
            dich registrierst, werden deine Daten auf dem Server gespeichert.
            Wenn du dich nicht registrierst und den Test als Gast abschließt,
            werden auch keine Daten am Server gespeichert.
          </p>
          <p>
            <h2>Bleiben meine Ergebnisse gespeichert?</h2>
            Nachdem du alle Bilder bei Jopsy bewertet hast, wird dein Ergebnis
            auf dem Server gespeichert, wenn du dich registriert hast. Bei
            neuerlicher Anmeldung siehst du sofort dein Ergebnis: Deine Top 3
            Interessentypen und die Favoriten deiner Berufsvorschläge. Wenn du
            Jopsy als Gast gemacht hast, bleibt dein Ergebnis nur lokal im
            aktuellen Browser-Fenster gespeichert und wird gelöscht, wenn du die
            Seite schließt.
          </p>
          <p>
            <h2>Kann ich den Test wiederholen?</h2>
            Wenn du den Button{' '}
            <span className={s.restart}>
              <img src={getAssetLink('ResetIcon.png')} alt="zurücksetzen" />
            </span>{' '}
            drückst, kannst du Jopsy noch einmal neu machen. Es werden aber
            deine vorherigen Ergebnisse gelöscht.
          </p>
        </div>
      </div>
    </div>
  );
}

export default withSEO({
  title: 'Jopsy | Hier sind die Facts!',
  description:
    'Interessierst du dich für die Fakten rund um Jopsy? Dann bist du hier genau richtig!',
})(Facts);
